<div class="@container/main block">
  <div class="flex flex-col @5xl/main:flex-row gap-5">
    <!-- main -->
    <div class="@container/center flex-1 grid grid-cols-12 gap-5">
      <app-dashboard-assistant-card-skeleton class="inline @5xl/main:hidden col-span-12" />
      <div class="col-span-12 grid grid-cols-1 @2xl/center:grid-cols-2 gap-5 auto-rows-fr">
        <app-dashboard-summary-card-skeleton />
        <app-dashboard-summary-card-skeleton />
      </div>
      <app-dashboard-list-card-skeleton class="col-span-12 @3xl/center:col-span-4">
        <ui-skeleton class="block h-6 w-full rounded-full" />
      </app-dashboard-list-card-skeleton>
      <app-dashboard-list-card-skeleton class="col-span-12 @3xl/center:col-span-4">
        <ul class="flex-1 flex flex-col gap-2">
          <li class="flex gap-3 items-center">
            <ui-skeleton class="block size-5 flex-none rounded-md" />
            <ui-skeleton class="block h-3.5 flex-1 rounded-full" />
          </li>
          <li class="flex gap-3 items-center">
            <ui-skeleton class="block size-5 flex-none rounded-md" />
            <ui-skeleton class="block h-3.5 flex-1 rounded-full" />
          </li>
        </ul>
      </app-dashboard-list-card-skeleton>
      <app-dashboard-list-card-skeleton class="col-span-12 @3xl/center:col-span-4">
        <ul class="flex-1 flex flex-col gap-2">
          <li class="flex gap-3 items-center">
            <ui-skeleton class="block size-5 flex-none rounded-md" />
            <ui-skeleton class="block h-3.5 flex-1 rounded-full" />
          </li>
        </ul>
      </app-dashboard-list-card-skeleton>
      <app-dashboard-hpfc-skeleton class="col-span-12" />
    </div>
    <!-- sidebar -->
    <div
      class="flex-none @5xl/main:w-[311px] grid grid-cols-1 md:grid-cols-2 @5xl/main:flex flex-col gap-5"
    >
      <app-dashboard-assistant-card-skeleton class="hidden @5xl/main:inline" />
      <app-dashboard-consultant-card-skeleton />
      <app-dashboard-help-center-card-skeleton *appFeatureEnabled="'helpCenter'" />
    </div>
  </div>
</div>
